import React, { useState } from "react";
import { Modal, Form, Select, Button } from "antd";

const { Option } = Select;

/**
 * @param {Object} props
 * @param {boolean} props.visible - Whether the modal is visible.
 * @param {Function} props.onClose - Function to close the modal.
 * @param {Array<{ label: string, value: string }>} props.campaigns - List of campaigns to show in dropdown.
 * @param {Function} props.onContribute - Callback when user confirms the campaign selection.
 */
const CampaignDonationModal = ({
  visible,
  onClose,
  campaigns,
  onContribute,
}) => {
  const [form] = Form.useForm();

  const handleOk = () => {
    form.validateFields().then((values) => {
      onContribute(values.campaignId);
      form.resetFields();
      onClose();
    });
  };

  const handleCancel = () => {
    form.resetFields();
    onClose();
  };

  return (
    <Modal
      title="Select a Campaign to Donate"
      visible={visible}
      onCancel={handleCancel}
      style={{
        top: 150,
      }}
      footer={[
        <Button key="cancel" onClick={handleCancel} style={{  borderColor: "green", color: "green" }}>
          Cancel
        </Button>,
        <Button key="submit" type="primary" onClick={handleOk} style={{ color: "white", backgroundColor: "green", borderColor: "green" }}>
          Donate Now
        </Button>,
      ]}
    >
      <Form form={form} layout="vertical">
        <Form.Item
          name="campaignId"
          label="Campaign"
          rules={[{ required: true, message: "Please select a campaign" }]}
        >
          <Select
            showSearch
            placeholder="Search and select a campaign"
            optionFilterProp="children" // enables filtering by visible text (label)
            filterOption={(input, option) =>
              option?.children?.toLowerCase().includes(input.toLowerCase())
            }
          >
            {campaigns.map((campaign) => (
              <Option key={campaign.value} value={campaign.value}>
                {campaign.label}
              </Option>
            ))}
          </Select>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default CampaignDonationModal;
